import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from '@github-ui/code-view/App'
import {CodeViewEntrypoint} from '@github-ui/code-view/CodeViewLegacy'

// eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
registerNavigatorApp('react-code-view', () => ({
  App,
  routes: [
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({path: '/:owner/:repo/tree/:branch/:path/*', Component: CodeViewEntrypoint, shouldNavigateOnError: true}),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({path: '/:owner/:repo/blob/:branch/:path/*', Component: CodeViewEntrypoint, shouldNavigateOnError: true}),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({
      path: '/:owner/:repo/blame/:branch/:path/*',
      Component: CodeViewEntrypoint,
      shouldNavigateOnError: true,
    }),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({path: '/:owner/:repo/edit/:branch/:path/*', Component: CodeViewEntrypoint, shouldNavigateOnError: true}),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({path: '/:owner/:repo/new/:branch/:path/*', Component: CodeViewEntrypoint, shouldNavigateOnError: true}),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({path: '/:owner/:repo/new/:branch/*', Component: CodeViewEntrypoint, shouldNavigateOnError: true}),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({
      path: '/:owner/:repo/tree/delete/:branch/:path/*',
      Component: CodeViewEntrypoint,
      shouldNavigateOnError: true,
    }),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({
      path: '/:owner/:repo/delete/:branch/:path/*',
      Component: CodeViewEntrypoint,
      shouldNavigateOnError: true,
    }),

    // We cannot use '/:owner/:repo/*' because it could intercept routes to other react apps, like '/:owner/:repo/pushes'
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({path: '/:owner/:repo', Component: CodeViewEntrypoint, shouldNavigateOnError: true}),
    // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
    jsonRoute({path: '/:owner/:repo/tree/:branch/*', Component: CodeViewEntrypoint, shouldNavigateOnError: true}),
  ],
}))
